import { inject, Pipe, PipeTransform } from '@angular/core';
import { MOMENT_SERVICE } from '@luggagehero/shared/interfaces';

@Pipe({ name: 'lhMoment', standalone: true })
export class MomentPipe implements PipeTransform {
  private momentService = inject(MOMENT_SERVICE);

  transform(value: string | Date, format = '', timezone?: string): string {
    return this.momentService.formatDate(value, format, timezone);
  }
}
